@for (part of parts; track part; let i = $index) {
  @if (i < selectedFormIndex && part.sidebarSummary && (part.type !== 'products' ||
    (part.type === 'products' && formGroup.controls.returnTrip?.value))) {
    <div class="wb-chapter">
      @if (formGroup.controls.returnTrip?.value) {
        <h4>{{(parts[i]?.summaryTitle || parts[i]?.title) | translate | ucFirst}}</h4>
      }
      @for (field of part.fields; track field) {
        <div class="wb-field">
          @if (field.type !== 'collapse' &&
            (field.type !== 'sortable-address' || formGroup.controls[field.property]?.value.length > 0) &&
            (formGroup.controls[field.property]?.value !== 0 && formGroup.controls[field.property]?.value !== '' && $safeNavigationMigration(formGroup.controls[field.property]?.value) !== null)) {
            <div class="wb-name"
              >
              {{(field.label ? field.label : field.placeholder) | translate | ucFirst}}
            </div>
          }
          @if (field.type !== 'collapse' && formGroup.controls[field.property]?.value !== 0 &&
            formGroup.controls[field.property]?.value && $safeNavigationMigration(formGroup.controls[field.property]?.value) !== null) {
            <div>
              <app-field-value [field]="field" [form]="form" [formGroup]="formGroup"></app-field-value>
            </div>
          }
          @for (field of field.fields; track field) {
            <div class="wb-field">
              @if (field.type !== 'collapse' && formGroup.controls[field.property]?.value !== 0 &&
                formGroup.controls[field.property]?.value !== '' && $safeNavigationMigration(formGroup.controls[field.property]?.value) !== null) {
                <div class="wb-name"
                  >{{field.label |
                translate | ucFirst}}</div>
              }
              <app-field-value [field]="field" [form]="form" [formGroup]="formGroup"></app-field-value>
            </div>
          }
        </div>
      }
    </div>
  }
}
